<template>
  <div class="flex flex-row flex-wrap gap-2">
    <template v-for="role in roles" :key="role">
      <div v-if="editionMode || modelValue.includes(role)">
        <PermissionButton
          :guard-type="'role'"
          :guard-name="role"
          :label="
            $t(`enums.config.permissions.roles.${role}`) ===
            `enums.config.permissions.roles.${role}`
              ? role
              : $t(`enums.config.permissions.roles.${role}`)
          "
          :disabled="
            !editionMode ||
            (modelValue.length <= 1 && modelValue.includes(role))
          "
          :selected="modelValue.includes(role)"
          @click="editionMode ? addOrRemove(role) : undefined"
        />
      </div>
    </template>
  </div>
</template>

<script>
import PermissionButton from '@c/RolesAndPermissions/component/PermissionButton.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'UserRoleListCheckboxes',
  components: { PermissionButton },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    roles: {
      type: Array,
      required: true,
      default: () => []
    },
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    ...mapGetters({
      authUser: 'auth/getUser'
    }),
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    addOrRemove(role) {
      if (this.localModelValue.length === 1 && this.localModelValue[0] === role)
        return
      const index = this.localModelValue.indexOf(role)
      if (index !== -1) {
        this.localModelValue.splice(index, 1)
      } else {
        this.localModelValue.push(role)
      }
    }
  }
}
</script>
